import { useEffect, useState } from "react";
import useIsMobile from "./useIsMobile";

export default function useHeaderShrink() {
  const isMobile = useIsMobile(); // Call the hook here

  const [headerHeight, setHeaderHeight] = useState(getInitialHeight());
  const [isScrolled, setIsScrolled] = useState(window.scrollY > 50);

  function getInitialHeight() {
    if (isMobile) return "4.5rem"; // Use isMobile here
    return window.scrollY > 50 ? "4.5rem" : "5.5rem";
  }

  useEffect(() => {
    const updateHeader = () => {
      const scrolled = window.scrollY > 50;
      setIsScrolled(scrolled);

      if (isMobile) { // Use isMobile here
        setHeaderHeight("4.5rem");
      } else {
        setHeaderHeight(scrolled ? "4.5rem" : "5.5rem");
      }
    };

    window.addEventListener("scroll", updateHeader);
    window.addEventListener("resize", updateHeader);
    updateHeader(); // call immediately on mount

    return () => {
      window.removeEventListener("scroll", updateHeader);
      window.removeEventListener("resize", updateHeader);
    };
  }, [isMobile]); // Add isMobile to the dependency array

  return { headerHeight, isScrolled };
}
